<template>
  <div class="filter-template" style="position: relative">
    <button class="btn btn-secondary dropdown-toggle" type="button" :id="'dropdownMenuButton_' + source" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" style="padding:10px;height:100%;">
      {{ label }}
    </button>
    <div class="dropdown-menu dropdown-filter-rentals" :aria-labelledby="'dropdownMenuButton_' + source" style="position: absolute; right:0; left: auto">
      <div>
        <div v-if="!showGroups" class="form-group form-material rental-search">
          <input type="text" class="form-control" :placeholder="placeholder" v-model="search"/>
        </div>
        <div style="overflow-y: auto;">
          <div v-if="groups.length > 0">
            <ul
              class="checkbox-custom m-l-30 checkbox-primary rental-group rental-group-ul"
              v-for="group in groups"
              :key="group.id"
            >
              <div v-if="group.elems.length > 0">
                <input
                  type="checkbox"
                  :id="`calendar-group-${group.id}`"
                  v-model="group.checked"
                  @change="toggleGroup(group)"
                />
                <label
                  :for="`calendar-group-${group.id}`"
                  class="rental-item-name"
                >
                  <span> {{ group.name }} </span>
                </label>
                <li
                  v-for="elem in group.elems"
                  :key="elem.id"
                  class="checkbox-custom m-l-10 checkbox-inline checkbox-primary dropdown-item"
                >
                  <input
                    type="checkbox"
                    :id="`calendar-rental-${elem.id}`"
                    v-model="elem.checked"
                    @change="toggleElem(elem)"
                  />
                  <label
                    :for="`calendar-rental-${elem.id}`"
                    class="rental-item-name"
                  >
                    <span> {{ elem.name }} </span>
                  </label>
                </li>
              </div>
            </ul>
          </div>
          <div v-if="groups.length === 0">
            <ul
            >
              <li
                v-for="elem in filteredElems"
                :key="elem.id"
                class="checkbox-custom checkbox-primary dropdown-item"
              >
                <input
                  type="checkbox"
                  v-model="elem.checked"
                  @change="toggleElem(elem)"
                />
                <label
                  class="elem-item-name"
                >
                  <span> {{ elem.name }} </span>
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="!showGroups" class="quick-actions">
          <div>
            <a class="clear-selected" @click.prevent="clearAll()">Effacer</a>
            <a class="btn btn-red btn-bold waves-effect waves-classic btn-with-caret"
               @click.prevent="filter()">Sauvegarder</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.dropdown-filter-rentals{
  padding-bottom: 0;
  padding-top: 0;
}
.dropdown-filter-rentals > div{
  position: relative;
  width: auto;
  display: inline-flex;
  flex-direction: column;
  overflow-y: hidden;
  max-height: 400px;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgb(0 0 0 / 10%);
  border: 1px solid #e0e0e0;
}
.rental-search{
  padding:5px 0 0 0;
  margin-bottom:0;
}
.rental-search .form-control{
  padding:10px;
}
.dropdown-filter-rentals .rental-group-ul{
  margin:0;
  /* overflow-y: auto; */
  overflow-x: hidden;
  padding:10px 0 10px 40px;
}
.dropdown-filter-rentals .quick-actions{
  z-index: 9;
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 10px 15px;
  border-top: 1px solid rgb(236, 236, 236);
  width: 300px;
  bottom: 0;
  cursor:default;
}
.dropdown-filter-rentals .quick-actions > div{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.dropdown-filter-rentals .quick-actions .clear-selected{
  text-decoration: underline;
  cursor:pointer;
}
.dropdown-filter-rentals .quick-actions .clear-selected:hover{
  text-decoration: none;
}
.dropdown-filter-rentals .quick-actions .btn{
  padding: 7px 15px !important;
  color: #fff;font-size: 11px;
}
</style>

<script>
export default {
  props: ['label', 'placeholder', 'source', 'showGroups'],
  data() {
    return {
      search: '',
      groups: [],
      checkedGroups: [],
      checkedElems: [],
      filteredElems: [],
      filterFallback: () => {},
    };
  },
  methods: {
    clearAll: function () {
      this.checkedGroups = [];
      this.checkedElems = [];
      this.search = '';
      this.elems = this.elems.map(e => {
        e.checked = false;
        return e;
      });
      this.filteredElems = this.filteredElems.map(e => {
        e.checked = false;
        return e;
      });
      // localStorage.setItem(this.source, JSON.stringify([]));
      this.filter();
    },
    toggleElem: function (elem) {
      if(elem.checked) {
        this.checkedElems.push(elem.id);
      }else{
        this.checkedElems = this.checkedElems.filter(id => id !== elem.id);
      }
    },
    toggleGroup: function (group) {
      if(group.checked) {
        this.checkedGroups.push(group.id);
        group.elems.forEach(elem => {
          elem.checked = true;
        })
      }else{
        this.checkedGroups = this.checkedGroups.filter(id => id !== group.id);
        group.elems.forEach(elem => {
          elem.checked = false;
        })
      }
    },
    filter: function (setStorage = true) {
      // if (setStorage) {
      //   localStorage.setItem(this.source, JSON.stringify(this.checkedElems));
      // }
      this.filterFallback(this.checkedElems);
    },
    updateOnStorage: function() {
      // const checkedElems = JSON.parse(localStorage.getItem(this.source));
      const checkedElems = null;
      if(checkedElems) {
        this.checkedElems = checkedElems;
        this.elems = this.elems.map(e => {
          e.checked = checkedElems.includes(e.id);
          return e;
        })
        this.filteredElems = this.filteredElems.map(e => {
          e.checked = checkedElems.includes(e.id);
          return e;
        })
        this.filter(false);
      }else {
        // localStorage.setItem(this.source, JSON.stringify(this.checkedElems));
        this.clearAll();
      }
    },
  },
  async mounted() {

    this.$root.$on(this.source + '_setFilterElemsWithGroups', elemsWithGroups => { });

    this.$root.$on(this.source + '_setFilterElems', elems => {
      this.elems = elems;
      this.filteredElems = this.elems;

      if(this.showGroups && this.elems && this.elems.length) {
        this.groups = this.elems.reduce((acc, elem) => {
          if (elem.group) {
            if (!acc.find(e => e.id === elem.group.id)) {
              acc.push({
                id: elem.group.id,
                name: elem.group.name,
                elems: [],
              });
            }
            acc.find(e => e.id === elem.group.id).elems.push(elem);
          }
          return acc;
        }, []);


        const otherGroup = {
          id: -1,
          name: 'Autres',
          elems: [],
        };
        otherGroup.elems = otherGroup.elems.concat(this.elems.filter(elem => !elem.group));
        this.groups.push(otherGroup);

      }
    });

    this.$root.$on(this.source + '_setFilterFallback', fallback => {
      this.filterFallback = fallback;
      this.updateOnStorage();
    });

  },
  watch: {
    search: function (val) {
      if (val.length > 2) {
        this.filteredElems = this.elems.filter(elem => elem.name.toLowerCase()
          .includes(val.toLowerCase()));
      } else {
        this.filteredElems = this.elems;
      }
    },
    checkedGroups: function (groups) {
      const uncheckedGroup = this.groups.find(group => !groups.includes(group.id));
      this.groups.forEach(group => {
        if(group.checked) {
          group.elems.forEach(elem => {
            elem.checked = true;
          })
        }
      });
      this.checkedElems = this.groups.reduce((acc, group) => {
        if(group.checked) {
          acc = acc.concat(group.elems.map(elem => elem.id));
        }
        group.elems.forEach(elem => {
          if(!uncheckedGroup || group.id !== uncheckedGroup.id) {
            elem.checked = group.checked;
          }
        });
        return acc;
      }, []);
      this.$forceUpdate();
      this.filter();
    },
    checkedElems: function (val) {
      this.groups.forEach(group => {
        if(group.elems.length > 0) {
          if(group.elems.every(elem => elem.checked)) {
            group.checked = true;
          }else{
            group.checked = false;
          }
        }
      });
      this.$forceUpdate();
      this.filter();
    },
  }
};
</script>



// WEBPACK FOOTER //
// FilterSelectorTemplate.vue?45cd887a